import Vue from "vue";
import base from "./baseCore";

export default Object.assign(
  {
    apiUrl: "/datawifi",

    async getCredentials(establishmentId) {
      const url = this.url(`/credentials/${establishmentId}`);
      return Vue.http.get(url);
    },
    async saveCredentials({
      establishmentId,
      accountName,
      customerId,
      password,
    }) {
      const url = this.url(`/credentials/${establishmentId}`);
      return Vue.http.post(url, {
        accountName,
        customerId,
        password,
      });
    },
    async getHeatMapRedirectUrl() {
      const url = this.url("/redirect-url");
      return Vue.http.get(url);
    },
  },
  base
);
